export const convertToFahrenheit = (value: number) => {
    if (value == null) return value;
    return value * 1.8 + 32;
}

export const convertToDegrees = (value: number) => {
    if (value == null) return value;
    return (value - 32) / 1.8;
}

export const convertToInches = (value: number) => {
    if (value == null) return value;
    return value * 0.0393700787;
}
export const convertToMm = (value: number) => {
    if (value == null) return value;
    return value / 0.0393700787;
}
